import { all, call, put, takeLatest, select } from 'redux-saga/effects'
import BookingAction, {
  BookingSelectors,
  BookingTypes,
} from '../Redux/BookingRedux'
import { ItemsPerPage } from '../Redux/genericReducers'

export function* getAll(api, action) {
  let params = action.params || {}

  if (!params.start_date || !params.end_date) {
    if (typeof action.listDataOffset !== 'undefined') {
      params.offset = action.listDataOffset
    } else {
      const listDataOffset = yield select(BookingSelectors.listDataOffset)
      params.offset = listDataOffset
    }
    params.limit = ItemsPerPage
  }

  const resp = yield call(api.getBookings, action.params)
  if (resp.ok) {
    yield put(BookingAction.bookingsListSuccess(resp.data))
  } else {
    yield put(BookingAction.bookingsListFailure('something went wrong'))
  }
}

export function* getAllCalendarData(api, action) {
  const resp = yield call(api.getCalendarBookings, action.params)
  if (resp.ok) {
    yield put(BookingAction.bookingsCalendarListSuccess(resp.data))
  } else {
    yield put(BookingAction.bookingsCalendarListFailure('something went wrong'))
  }
}

export function* getAllConflicts(api, action) {
  let params = action.params || {}
  if (typeof action.listDataOffset !== 'undefined') {
    params.offset = action.listDataOffset
  } else {
    const listDataOffset = yield select(BookingSelectors.listDataOffset)
    params.offset = listDataOffset
  }
  if (!params.limit) {
    params.limit = ItemsPerPage
  }

  const resp = yield call(api.getConflicts, action.params)
  if (resp.ok) {
    if (action.callback) {
      action.callback(resp.data)
    }
    yield put(BookingAction.bookingsConflictsListSuccess(resp.data))
  } else {
    yield put(
      BookingAction.bookingsConflictsListFailure('something went wrong')
    )
    if (action.callback) {
      action.callback([])
    }
  }
}

export function* getAllSubscriptions(api, action) {
  let params = action.params || {}
  if (typeof action.listDataOffset !== 'undefined') {
    params.offset = action.listDataOffset
  } else {
    const listDataOffset = yield select(BookingSelectors.listDataOffset)
    params.offset = listDataOffset
  }
  params.limit = ItemsPerPage

  const resp = yield call(api.getSubscriptions, action.params)
  if (resp.ok) {
    yield put(BookingAction.bookingsSubscriptionsListSuccess(resp.data))
  } else {
    yield put(
      BookingAction.bookingsSubscriptionsListFailure('something went wrong')
    )
  }
}

export function* getCancelledBookings(api, action) {
  let params = action.params || {}

  if (typeof action.listDataOffset !== 'undefined') {
    params.offset = action.listDataOffset
  } else {
    const listDataOffset = yield select(BookingSelectors.listDataOffset)
    params.offset = listDataOffset
  }
  params.limit = ItemsPerPage

  const resp = yield call(api.getCancelledBookings, action.params)
  if (resp.ok) {
    yield put(BookingAction.bookingsCancelListSuccess(resp.data))
  } else {
    yield put(BookingAction.bookingsCancelListFailure('something went wrong'))
  }
}

export function* getAllLegacySubscriptions(api, action) {
  const resp = yield call(api.getLegacySubscriptions)
  if (resp.ok) {
    yield put(BookingAction.bookingsLegacySubscriptionsListSuccess(resp.data))
  } else {
    yield put(
      BookingAction.bookingsLegacySubscriptionsListFailure(
        'something went wrong'
      )
    )
  }
}

export function* detailsRequest(api, action) {
  let apiCall = api.getBookingDetails
  if (!!action.cancelled) {
    apiCall = api.getCancelledBookingDetails
  }

  const resp = yield call(apiCall, {
    booking_id: action.id,
  })
  if (resp.ok) {
    let customers = []
    if (!!action.cancelled) {
      customers = resp.data.customers
    } else {
      customers = resp.data.customers.map((c) => {
        return {
          ...c,
          custom_fields: resp.data.custom_fields.filter(
            (cf) => cf.customer_id === c.id
          ),
        }
      })
    }

    yield put(
      BookingAction.bookingsDetailSuccess({
        ...resp.data,
        customers,
      })
    )
  } else {
    yield put(BookingAction.bookingsDetailFailure('something went wrong'))
  }
}

export function* subscriptionRequest(api, action) {
  const resp = yield call(api.getBookingSubscription, action.id)
  if (resp.ok) {
    yield put(BookingAction.bookingsSubscriptionSuccess(resp.data))
  } else {
    yield put(BookingAction.bookingsSubscriptionFailure('something went wrong'))
  }
}

export function* legacySubscriptionRequest(api, action) {
  const resp = yield call(api.getLegacyBookingSubscription, {
    customer_id: action.id,
  })
  if (resp.ok) {
    yield put(BookingAction.bookingsLegacySubscriptionSuccess(resp.data))
  } else {
    yield put(
      BookingAction.bookingsLegacySubscriptionFailure('something went wrong')
    )
  }
}

export function* subscriptionCancel(api, action) {
  const resp = yield call(api.deleteSubscription, action.id)
  if (resp.ok) {
    yield put(BookingAction.bookingsSubscriptionCancelSuccess(resp.data))
    action.callback()
  } else {
    yield put(
      BookingAction.bookingsSubscriptionCancelFailure('something went wrong')
    )
    action.callback()
  }
}

export function* onCancel(api, action) {
  const resp = yield call(api.cancelBooking, action.params)
  if (resp.ok) {
    yield put(BookingAction.bookingsCancelSuccess(resp.data))
    action.callback(action.params.count)
  } else {
    yield put(BookingAction.bookingsCancelFailure('something went wrong'))
  }
}

export function* onRestore(api, action) {
  const resp = yield call(api.restoreBooking, action.id, action.params)
  if (resp.ok) {
    yield put(BookingAction.bookingsRestoreSuccess(resp.data))
    action.callback(resp.data)
  } else {
    yield put(BookingAction.bookingsRestoreFailure('something went wrong'))
  }
}

export function* onEditBooking(api, action) {
  const resp = yield call(api.editBooking, action.id, action.params)
  if (resp.ok) {
    yield put(BookingAction.bookingsEditSuccess(resp.data))
    action.callback(resp.data)
  } else {
    yield put(BookingAction.bookingsEditFailure('something went wrong'))
  }
}

export function* onReschedule(api, action) {
  const resp = yield call(api.rescheduleBooking, action.params)
  if (resp.ok) {
    yield put(BookingAction.bookingsRescheduleSuccess(resp.data))
    action.callback(action.params.count)
  } else {
    yield put(BookingAction.bookingsRescheduleFailure('something went wrong'))
  }
}

export function* createNote(api, action) {
  const resp = yield call(api.createNote, action.id, action.params)
  if (resp.ok) {
    action.callback()
  } else {
    action.callback('failure')
  }
}

export function* deleteNote(api, action) {
  const resp = yield call(api.deleteNote, action.id, action.params)
  if (resp.ok) {
    action.callback()
  } else {
    action.callback('failure')
  }
}

export function* updateCustomer(api, action) {
  const resp = yield call(api.updateCustomer, action.id, action.params)
  if (resp.ok) {
    action.callback(action.params.count)
  } else {
    action.callback('failure')
  }
}

export function* updateAppointment(api, action) {
  const resp = yield call(api.updateAppointment, action.params)
  if (resp.ok) {
    action.callback()
  } else {
    action.callback('failure')
  }
}

export function* sendManualEmail(api, action) {
  for (let index = 0; index < action.params.length; index++) {
    const element = action.params[index]
    const resp = yield call(api.sendManualEmail, element)
  }

  action.callback()
}

export function* getAllActivities(api, action) {
  const resp = yield call(api.getActivities, action.params)
  if (resp.ok) {
    yield put(BookingAction.bookingsActivitiesListSuccess(resp.data))
  } else {
    yield put(
      BookingAction.bookingsActivitiesListFailure('something went wrong')
    )
  }
}
export function* getCancelledActivities(api, action) {
  const resp = yield call(api.getCancelledActivities, action.params)
  if (resp.ok) {
    yield put(BookingAction.bookingsActivitiesCancelledListSuccess(resp.data))
  } else {
    yield put(
      BookingAction.bookingsActivitiesCancelledListFailure(
        'something went wrong'
      )
    )
  }
}

export function* resendBookingEmail(api, action) {
  const resp = yield call(api.resendEmail, action.id, action.params)
  if (resp.ok) {
    action.callback()
  } else {
    action.callback('failure')
  }
}

export function* updateCustomerPaymentMethod(api, action) {
  const resp = yield call(api.updateCustomerPaymentMethod, action.params)
  if (resp.ok) {
    action.callback()
  } else {
    action.callback('failure')
  }
}

export function* bookingsByCustomer(api, action) {
  const resp = yield call(api.bookingsByCustomer, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  } else {
    action.callback('failure')
  }
}

export function* connectBookingToSubscription(api, action) {
  const resp = yield call(api.connectBookingToSubscription, action.params)
  if (resp.ok) {
    action.callback()
  } else {
    action.callback('failure')
  }
}

export function* importCSVModal(api, action) {
  const resp = yield call(api.startImport, action.params)
  if (resp.ok) {
    action.callback()
  } else {
    action.callback('failure')
  }
}

export function* updateSubscriptionDetails(api, action) {
  const resp = yield call(api.updateSubscriptionDetails, action.params)
  if (resp.ok) {
    action.callback()
  } else {
    action.callback('failure')
  }
}

export function* retrySubscriptionBilling(api, action) {
  const resp = yield call(api.retrySubscriptionBilling, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  } else {
    action.callback('failure')
  }
}

export function* bookingWorkflowsRequest(api, action) {
  const resp = yield call(api.getBookingWorkflows, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  } else {
    action.callback('failure')
  }
}

export function* upsertBookingStatus(api, action) {
  const resp = yield call(api.upsertBookingStatus, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  } else {
    action.callback('failure')
  }
}

export function* deleteBookingStatus(api, action) {
  const resp = yield call(api.deleteBookingStatus, action.id)
  if (resp.ok) {
    action.callback(resp.data)
  } else {
    action.callback('failure')
  }
}

export function* resendConfirmationEmail(api, action) {
  const resp = yield call(api.resendConfirmationEmail, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  }
}

export function* calculateRefund(api, action) {
  const resp = yield call(api.calculateRefund, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  }
}

export function* updateContractPrice(api, action) {
  const resp = yield call(api.updateContractPrice, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  }
}

export function* sendCustomerPortalLink(api, action) {
  const resp = yield call(api.sendCustomerPortalLink, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  }
}

export function* skipCycle(api, action) {
  const resp = yield call(api.skipCycle, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  }
}

export function* chargeSubscription(api, action) {
  const resp = yield call(api.chargeSubscription, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  }
}

export function* scheduleSubscriptionDate(api, action) {
  const resp = yield call(api.scheduleSubscriptionDate, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  }
}
export function* updateContractInterval(api, action) {
  const resp = yield call(api.updateContractInterval, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  } else {
    action.callback('something went wrong')
  }
}

export default function* authSagas(api) {
  yield all([
    takeLatest(BookingTypes.BOOKINGS_LIST_REQUEST, getAll, api),
    takeLatest(
      BookingTypes.BOOKINGS_CALENDAR_LIST_REQUEST,
      getAllCalendarData,
      api
    ),
    takeLatest(
      BookingTypes.BOOKINGS_CONFLICTS_LIST_REQUEST,
      getAllConflicts,
      api
    ),
    takeLatest(
      BookingTypes.BOOKINGS_SUBSCRIPTIONS_LIST_REQUEST,
      getAllSubscriptions,
      api
    ),
    takeLatest(
      BookingTypes.BOOKINGS_LEGACY_SUBSCRIPTIONS_LIST_REQUEST,
      getAllLegacySubscriptions,
      api
    ),
    takeLatest(BookingTypes.BOOKINGS_DETAIL_REQUEST, detailsRequest, api),
    takeLatest(
      BookingTypes.BOOKINGS_SUBSCRIPTION_REQUEST,
      subscriptionRequest,
      api
    ),
    takeLatest(
      BookingTypes.BOOKINGS_CANCEL_LIST_REQUEST,
      getCancelledBookings,
      api
    ),
    takeLatest(
      BookingTypes.BOOKINGS_LEGACY_SUBSCRIPTION_REQUEST,
      legacySubscriptionRequest,
      api
    ),
    takeLatest(
      BookingTypes.BOOKINGS_SUBSCRIPTION_CANCEL_REQUEST,
      subscriptionCancel,
      api
    ),
    takeLatest(BookingTypes.BOOKINGS_CANCEL_REQUEST, onCancel, api),
    takeLatest(BookingTypes.BOOKINGS_RESTORE_REQUEST, onRestore, api),
    takeLatest(BookingTypes.BOOKINGS_EDIT_REQUEST, onEditBooking, api),
    takeLatest(BookingTypes.BOOKINGS_RESCHEDULE_REQUEST, onReschedule, api),
    takeLatest(BookingTypes.BOOKING_NOTE_CREATE_REQUEST, createNote, api),
    takeLatest(BookingTypes.BOOKING_NOTE_DELETE_REQUEST, deleteNote, api),
    takeLatest(BookingTypes.UPDATE_CUSTOMER, updateCustomer, api),
    takeLatest(BookingTypes.UPDATE_APPOINTMENT, updateAppointment, api),
    takeLatest(BookingTypes.SEND_MANUAL_EMAIL, sendManualEmail, api),
    takeLatest(
      BookingTypes.BOOKINGS_ACTIVITIES_LIST_REQUEST,
      getAllActivities,
      api
    ),
    takeLatest(
      BookingTypes.BOOKINGS_ACTIVITIES_CANCELLED_LIST_REQUEST,
      getCancelledActivities,
      api
    ),
    takeLatest(BookingTypes.RESEND_BOOKING_EMAIL, resendBookingEmail, api),
    takeLatest(
      BookingTypes.UPDATE_CUSTOMER_PAYMENT_METHOD,
      updateCustomerPaymentMethod,
      api
    ),
    takeLatest(BookingTypes.BOOKINGS_BY_CUSTOMER, bookingsByCustomer, api),
    takeLatest(
      BookingTypes.CONNECT_BOOKING_TO_SUBSCRIPTION,
      connectBookingToSubscription,
      api
    ),
    takeLatest(BookingTypes.IMPORT_CSV_MODAL, importCSVModal, api),
    takeLatest(
      BookingTypes.UPDATE_SUBSCRIPTION_DETAILS,
      updateSubscriptionDetails,
      api
    ),
    takeLatest(
      BookingTypes.RETRY_SUBSCRIPTION_BILLING,
      retrySubscriptionBilling,
      api
    ),
    takeLatest(
      BookingTypes.BOOKING_WORKFLOWS_REQUEST,
      bookingWorkflowsRequest,
      api
    ),
    takeLatest(
      BookingTypes.BOOKING_STATUS_UPSERT_REQUEST,
      upsertBookingStatus,
      api
    ),
    takeLatest(
      BookingTypes.RESEND_CONFIRMATION_EMAIL,
      resendConfirmationEmail,
      api
    ),
    takeLatest(
      BookingTypes.BOOKING_STATUS_DELETE_REQUEST,
      deleteBookingStatus,
      api
    ),
    takeLatest(BookingTypes.CALCULATE_REFUND, calculateRefund, api),
    takeLatest(
      BookingTypes.UPDATE_CONTRACT_PRICE_REQUEST,
      updateContractPrice,
      api
    ),
    takeLatest(
      BookingTypes.SEND_CUSTOMER_PORTAL_LINK_REQUEST,
      sendCustomerPortalLink,
      api
    ),
    takeLatest(BookingTypes.SKIP_CYCLE_REQUEST, skipCycle, api),
    takeLatest(
      BookingTypes.CHARGE_SUBSCRIPTION_REQUEST,
      chargeSubscription,
      api
    ),
    takeLatest(
      BookingTypes.SCHEDULE_SUBSCRIPTION_DATE_REQUEST,
      scheduleSubscriptionDate,
      api
    ),
    takeLatest(
      BookingTypes.UPDATE_CONTRACT_INTERVAL_REQUEST,
      updateContractInterval,
      api
    ),
  ])
}
